export const MODULE_NAME = 'views/cottage-unique-register'

export const NUXT_PAGE_OWNER_COTTAGE_UNIQUE_REGISTER = 'legal'
